/**
 * EcommercePresenter — Abstract base class (interface) for ecommerce UI strategies.
 *
 * Both DesktopPresenter and MobilePresenter implement this contract so that
 * EcommerceManager can delegate all UI operations without branching on device type.
 *
 * Subclasses MUST override every method below.
 */
export class EcommercePresenter {

  /**
   * Render the product list/picker/carousel.
   * @param {Array}  products - Normalized product objects
   * @param {string} title    - Header text
   * @param {string} layout   - 'cards' | 'list' (desktop may use; mobile may ignore)
   */
  showProducts(products, title, layout) {
    throw new Error('EcommercePresenter.showProducts() not implemented');
  }

  /**
   * Remove/hide any currently displayed products.
   */
  hideProducts() {
    throw new Error('EcommercePresenter.hideProducts() not implemented');
  }

  /**
   * Visual feedback after a product was added to the cart.
   * Typically shows a toast and then hides the product display.
   * @param {Object} product  - The product that was added
   * @param {Object} cartInfo - { itemCount, total, currency }
   */
  onProductAdded(product, cartInfo) {
    throw new Error('EcommercePresenter.onProductAdded() not implemented');
  }

  /**
   * Update the cart summary UI with new totals.
   * @param {Object} cartInfo - { itemCount, total, currency }
   */
  updateCart(cartInfo) {
    throw new Error('EcommercePresenter.updateCart() not implemented');
  }

  /**
   * Tear down all DOM elements and event listeners.
   */
  destroy() {
    throw new Error('EcommercePresenter.destroy() not implemented');
  }
}
